import IJobSection from "../../interfaces/IJobSection";
import { BoxHeader } from "./box-header";
import { LogoHope } from "./logo-hope";
import { CheckedSpinner } from "./checked-spinner";
import { useResultsContext } from "../../context/results-context";
import { Section } from "./section";

export function SectionMutantDescription({section}: {section: IJobSection}) {
  const {results} = useResultsContext();
  const hope = results?.hope;
  const loading = !hope || hope.aminoAcidPropertiesReport === null;
  return (
    <Section section={section} className="ll-break-inside-avoid" style={{marginTop: '1rem'}}>
      <LogoHope/>
      <BoxHeader section={section}/>
      {loading ? (
        <div className="ll-section-body ll-section-spinner">
          <CheckedSpinner withText={true} errTextBefore={'No response from the HOPE server.'}/>
        </div>
      ) : (
        <ul style={{padding: '0 3rem'}} className="ll-section-body">
          {hope.aminoAcidPropertiesReport.map((v, i) => <li key={i}>{v}</li>)}
        </ul>
      )}
    </Section>
  )
}